import React from 'react'
import useDebounce from '@/utils/hooks/useDebounce'
import { API_URL } from '@/utils/constants'
import axios from 'axios'
import SnsResolve from '@/components/sns-resolve'

type SnsResult = { name?: string } & Record<string, any>

export default function useResolveSns(recipient?: string): any {
	const [value, setValue] = React.useState(recipient ? recipient : '')
	const [loading, setLoading] = React.useState(false)
	const [sns, setSns] = React.useState<SnsResult | null>(null)
	const [error, setError] = React.useState<boolean | null>(null)
	const debouncedValue: string = useDebounce<string>(value, 300)
	const visibleSns = debouncedValue === sns?.name ? sns : null

	const resolveSnsEl = <SnsResolve error={!!error} sns={visibleSns} />

	React.useEffect(() => {
		async function run() {
			setLoading(true)
			setSns(null)
			try {
				const { data } = await axios.post(`${API_URL}/sns/resolve`, { name: debouncedValue })
				setSns(data)
			} catch (e) {
				console.log(e)
				setError(true)
			}

			setLoading(false)
		}

		if (debouncedValue?.includes('.')) {
			run()
		}
	}, [debouncedValue])

	const handleChange = React.useCallback(
		(evt: React.ChangeEvent<HTMLInputElement>) => {
			if (loading) {
				return
			}

			setError(false)
			setValue(evt.target.value)
		},
		[loading]
	)

	return { error, value, setValue, handleChange, loading, sns: visibleSns, resolveSnsEl }
}
